import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 45px;
  box-shadow: 0px 10px 60px 0px rgb(0 0 0 / 10%),
    0px 0px 0px 1px rgb(0 0 0 / 1%);
  border-top: solid 3px #185335;

  @media screen and (min-width: 992px) {
    display: flex;
  }

  .video,
  .info {
    padding: 30px;

    @media screen and (min-width: 992px) {
      flex: 1 1 50%;
    }
  }

  .video {
    iframe {
      width: 100%;
      height: auto;
      min-height: 280px;
      outline: 0;
      border: none;
      background-color: rgba(0, 0, 0, 0.1);
    }
  }

  .info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    &__title {
      font-weight: bold;
      margin-bottom: 30px;
    }

    &__button {
      display: inline-block;
      outline: none;
      border-radius: 6px;
      padding: 6px 10px;
      color: #fff;
      background-color: #185335;
      border: solid 1px #185335;

      &:hover {
        background-color: #12482d;
        border: solid 1px #12482d;
      }
    }
  }
`;
